import { SelectBase } from './SelectBase';
import { withSelect2 } from './withSelect2';
import { modelChooser } from '~/brandsRequest';
import { curry } from 'ramda';

const getModelsByBrandId = curry(modelChooser)('/api/Brand/getModels/');

export const Select2Model = {
	name: 'Select2Model',
	extends: SelectBase,
	props: {
		brandId: String,
	},
	mixins: [
		withSelect2(vm => ({
			placeholder: {
				id: '',
				text: 'Выберите модель',
			},
			ajax: {
				transport: ({ data: { q: query }}, success, failure) => {
					return getModelsByBrandId(vm.brandId)
						.then((results) =>
							query ?
							results.filter(({ NAME }) => NAME.toLowerCase().includes(query.toLowerCase())) :
							results
						)
						.then(success)
						.catch(failure);
				},
				processResults: models => ({
					results: models.map(({ ID, NAME }) => ({ id: ID, text: NAME })),
				}),
			},
		})),
	],
}
